<script setup lang="ts">
import { defineProps } from "vue/dist/vue";
import TitleBase from "@/components/Titles/TitleBase.vue";

const props = defineProps<{
  text: string;
}>();
</script>

<template>
  <TitleBase class="text-4xl md:text-5xl" :text="props.text" />
</template>
